export const DividerStyle = {
  dashed: {
    margin: 0,
    marginBottom: '8px',
    marginTop: '8px',
    width: '100%',
    height: '1px',
    background: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23333' stroke-width='4' stroke-dasharray='4%2c 14' stroke-dashoffset='-1' stroke-linecap='square'/%3e%3c/svg%3e")`,
    opacity: 0.2,
  },
};

export default DividerStyle;
